/* eslint-disable code-style/folder-structure-consistency */

import { modulesConstants } from "@/constants";

export const sidebarTabsData = {
    "/admins": {
        id: 1,
        route: modulesConstants.admins,
    },
    "/events": {
        id: 2,
        route: modulesConstants.events,
    },
    "/events/templates": {
        id: 3,
        route: modulesConstants.eventTemplates,
    },
    "/photographers": {
        id: 4,
        route: modulesConstants.photographers,
    },
};
